const o=0,t=1;export{t as BUTTON_TRANSITION_MODE_SPRITE_CHANGE,o as BUTTON_TRANSITION_MODE_TINT};
